import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  API_LOADING_ERROR,
  API_NO_DATA_FOUND_ERROR,
  API_NOT_FOUND_ERROR,
  ERROR_STATUS_CODES,
} from "@/lib/errors/error-constants";

export const getIndividualStatsData = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/cost-anomaly/individualStatsData`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (
      (!data?.aws?.totalAnomalyCost || data.aws.totalAnomalyCost === 0) &&
      (!data?.azure?.totalAnomalyCost || data.azure.totalAnomalyCost === 0) &&
      (!data?.gcp?.totalAnomalyCost || data.gcp.totalAnomalyCost === 0)
    ) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return data;
  };
};

export const getIndividualGraphData = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/cost-anomaly/individualChartData`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (
      (!data?.aws?.totalAnomalies || data.aws.totalAnomalies === 0) &&
      (!data?.azure?.totalAnomalies || data.azure.totalAnomalies === 0) &&
      (!data?.gcp?.totalAnomalies || data.gcp.totalAnomalies === 0)
    ) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return data;
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const useIndividualStatsData = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getIndividualStatsData", req, ...deps],
    queryFn: () => getIndividualStatsData(appContext.idToken)(req),
  });
  return query;
};

export const useIndividualGraphData = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getIndividualGraphData", req, ...deps],
    queryFn: () => getIndividualGraphData(appContext.idToken)(req),
  });
  return query;
};
